import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import Notifications from "../views/Notifications.vue";
import Profile from "../views/Profile.vue";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";
import Cookies from 'js-cookie'
import { httpPost } from '../services/axios'
import Tracking from "../views/Tracking.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/tracking",
    name: "tracking",
    component: Tracking,
    meta: {
      requiresAuth: true
    }    
  },  
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp,
  },
  {
    path: "/sign-out",
    name: "SignOut",
    beforeEnter: async (to, from, next) => {
      let res = await httpPost('/logout')
      if (res.status == 200) next('/sign-in')
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Guardian
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_meta')

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'SignIn' })
  } else {
    next()
  }
})

export default router;
